var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCongratulationTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5932",
    "data-name": "Group 5932",
    xmlns: "http://www.w3.org/2000/svg",
    width: 113.615,
    height: 113.62,
    viewBox: "0 0 113.615 113.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_89825",
    "data-name": "Path 89825",
    d: "M114.188,42.988a18.976,18.976,0,0,0-9.409-11.893,18.976,18.976,0,0,0-5.6-14.166A19.346,19.346,0,0,0,85.01,11.273,19.293,19.293,0,0,0,58.052,4.084a19.24,19.24,0,0,0-26.958,7.242A19.188,19.188,0,0,0,11.325,31.095,19.24,19.24,0,0,0,4.084,58.052,19.24,19.24,0,0,0,11.325,85.01a18.976,18.976,0,0,0,5.6,14.166,19.4,19.4,0,0,0,14.166,5.656,19.293,19.293,0,0,0,26.958,7.189A19.24,19.24,0,0,0,68.1,114.875a18.235,18.235,0,0,0,5.022-.687,18.976,18.976,0,0,0,11.893-9.409A19.188,19.188,0,0,0,104.779,85.01a19.24,19.24,0,0,0,7.242-26.958,19.029,19.029,0,0,0,2.167-15.065Zm-28.7,0L54.4,74.068a3.753,3.753,0,0,1-2.8,1.163,3.912,3.912,0,0,1-2.8-1.163L32.1,57.577a3.964,3.964,0,1,1,5.6-5.6l13.9,13.9L79.883,37.6a3.964,3.964,0,0,1,5.6,5.6Z",
    transform: "translate(-1.255 -1.255)",
    fill: "#0b9100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongratulationTick);
export default __webpack_public_path__ + "static/media/CongratulationTick.ec28d7f50953f6a5ed4f01d900d9d03c.svg";
export { ForwardRef as ReactComponent };